<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="dialog-title title"></h5>
                    <div class="record-view">
                        <div class="data-head">
                            <div class="label">获得时间</div>                          
                            <div class="label">获得道具</div>
                            <div class="label">消耗金鸡币</div>
                        </div>

                        <vuescroll v-if="list">
                            <div class="data-view">
                                <div class="data-item" v-for="(item,index) in list" :key="index" :class="{'odd' : index/2 == 0,'even' : index/2 > 0}">
                                    <div class="time table-cell">{{ item.payTime || '----------- --:--:--' }}</div>  
                                    <div class="detail table-cell">
                                        <div class="item-name">
                                            <p class="order-item" v-for="(r,k) in item.giftList" :key="k">{{ r.giftName }}*{{ r.num }}</p>                                            
                                        </div>
                                    </div>
                                    <div class="cost table-cell">{{ item.amount || 0 }}</div>                                    
                                </div>
                            </div>
                        </vuescroll>

                        <div class="empty" v-if="!list.length"></div>

                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.record-modal{
    position: relative;
    width: 667px;
    height: 521px;
    background-image: url(~@/assets/images/modal/bg-modal_lg2.png);
}

.title{
    width: 429px;
    height: 64px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/modal/title-record.png);    
}

.record-view{
    width: 635px;
    height: 350px;
    margin-left: 20px;
    text-align: center;
    color: #7c3700;  
}

.data-head{
    width: 541px;
    height: 25px;
    margin: 0 auto 10px;
    font-size: 0;
    color: transparent;
    background-image: url(~@/assets/images/modal/table-head.png);    
}

.data-item{
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    width: 615px;
    margin-bottom: 10px;
    padding: 8px 20px;
    font-size: 22px;
    color: #cbbda5;
    box-sizing: border-box;
    border: 1px solid #cbbda5;
    /* border-radius: 40px; */
}

.table-cell{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 0;
    box-sizing: border-box;
    word-break: break-all;
    overflow: hidden;
}

.table-cell.time{

}

.table-cell.cost{
    width: 168px;
}

.table-cell.index{
    width: 65px;
}

.table-cell.detail{
    width: 190px;
    margin-left: 10px;
}

.list{
    display: flex;
}

.reward-item{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    margin: 0 0;
    /* background-image: url(~@/assets/images/modal/bg-item_2.png); */
    background-size: 100% 100%; 
}

.pic{
    width: 46px;
    height: 46px;
}

.data-item .time{

}


.empty{
    width: 475px;
    height: 415px;
    margin-left: -20px;
    margin-top: 20px;
    /* background-image: url(~@/assets/images/modal/record-none.png); */
}

</style>


<script>
export default {
    data () {
        return {
            dialogVisible : false,
            list : [],
            opt : {
                passive: false, //强调默认事件
                capture: true, //早点禁止该事件               
            },
            // stopTouch : false,                          
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.dialogVisible = false
                this.destroyElement()
            }
        }
    },
    created (){
        this.afterOpen();
    },
    methods : {
        destroyElement () {
            this.beforeClose();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        afterOpen () {
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', this.stopTouch, this.opt); // 禁止页面滑动          
        },
        beforeClose (){
            document.body.style.overflow = ''; // 出现滚动条
            document.removeEventListener('touchmove', this.stopTouch, this.opt);         
        },         
        closeModal(){
            this.destroyElement()
        },
        toDouble (num){
            return num > 9 ? num : '0' + num;
        }        
    },    
}
</script>